import { useSearchParams } from "../../../../../browser-utils/useSearchParams";

export const useShouldShowDocumentToolbar = () => {
  const { assetCollectionTemplateId } = useSearchParams() as {
    assetCollectionTemplateId: string;
  };
  return !assetCollectionTemplateId;
};
